import { type PieChartsOptions } from "@client/lib/jquery/piecharts";
import { combinedSettingsSelector, TargetSelector } from "@client/selectors";

export const makePieChartsOptionsSelector = () =>
  combinedSettingsSelector<PieChartsOptions>(TargetSelector.Entity, [
    { name: "color", prop: "barColor", type: "color" },
    { name: "pieWidth", prop: "lineWidth" },
    { name: "pieRadius", prop: "size" }
  ]);
